export type SysMaddEnvironment = 'development' | 'homologation' | 'production';

export function getSysMaddEnvironment(): SysMaddEnvironment {
  const configured = String(process.env.REACT_APP_SYSMADD_ENV || '').trim().toLowerCase();
  if (configured === 'homologation' || configured === 'production' || configured === 'development') {
    return configured;
  }
  return process.env.NODE_ENV === 'production' ? 'production' : 'development';
}

export const SYSMADD_ENVIRONMENT = getSysMaddEnvironment();
export const IS_HOMOLOGATION = SYSMADD_ENVIRONMENT === 'homologation';
export const IS_PRODUCTION = SYSMADD_ENVIRONMENT === 'production';
export const IS_DEVELOPMENT = SYSMADD_ENVIRONMENT === 'development';
